const couponsissuingmanagement = resolve => require(["@/components/couponsmanagement/couponsissuingmanagement/index.vue"],resolve);
const checkCoupons = resolve => require(["@/components/couponsmanagement/couponsissuingmanagement/checkCoupons.vue"],resolve);
const releaseCoupons = resolve => require(["@/components/couponsmanagement/couponsissuingmanagement/releaseCoupons/index.vue"],resolve);
const couponsinfomanagement = resolve => require(["@/components/couponsmanagement/couponsinfomanagement/index.vue"],resolve);
const checkInfo = resolve => require(["@/components/couponsmanagement/couponsinfomanagement/module/check.vue"],resolve);

export default [
  {
    path:"/homeMain/couponsmanagement/couponsissuingmanagement",
    component: couponsissuingmanagement
  },
  {
    path:"/homeMain/couponsmanagement/checkCoupons",
    component:checkCoupons
  },
  {
    path:"/homeMain/couponsmanagement/releaseCoupons",
    component:releaseCoupons
  },
  {
    path:"/homeMain/couponsmanagement/couponsinfomanagement",
    component: couponsinfomanagement
  },
  {
    path:"/homeMain/couponsmanagement/checkInfo",
    component: checkInfo
  },
]



// WEBPACK FOOTER //
// ./src/router/couponsmanagement.js